/* global Image, MediaElement */ function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { CSSTransition } from "react-transition-group";
import "mediaelement";
import "mediaelement/build/mediaelementplayer.min.css";
import "mediaelement/build/mediaelement-flash-video.swf";
var hasSomeParentClass = function(element, className) {
    return !!element && (element.classList.contains(className) || hasSomeParentClass(element.parentElement, className));
};
var AppModal = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(AppModal, PureComponent);
    var _super = _createSuper(AppModal);
    function AppModal(props) {
        _classCallCheck(this, AppModal);
        var _this;
        _this = _super.call(this, props);
        _this.handleClose = function() {
            if (_this.media) {
                _this.media.pause();
            }
            _this.props.close();
            _this.setState({
                loading: false,
                contentUrl: null,
                contentType: null
            });
        };
        _this.handleClick = function(evnt) {
            if (!evnt.target.matches(".tinyaction-image") && !evnt.target.matches(".tinyaction-video") && !hasSomeParentClass(evnt.target, "tinyaction-image") && !hasSomeParentClass(evnt.target, "tinyaction-video")) {
                return;
            }
            evnt.preventDefault();
            var elem = evnt.target.matches(".tinyaction-image") || evnt.target.matches(".tinyaction-video") ? evnt.target : evnt.target.closest(".tinyaction-image") || evnt.target.closest(".tinyaction-video");
            var taAction = elem.className.match(/.*tinyaction-([a-z]+)/);
            if (_this._isMounted) {
                _this.setState({
                    loading: !!taAction && !!elem.href && taAction[1] === "image",
                    contentUrl: elem.href,
                    contentType: taAction ? taAction[1] : null
                }, _this.props.show);
            }
        };
        _this.mediaEL = null;
        _this.media = null;
        _this.state = {
            loading: true,
            contentUrl: null,
            contentType: null
        };
        return _this;
    }
    var _proto = AppModal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        document.addEventListener("click", this.handleClick);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this._isMounted = false;
        document.removeEventListener("click", this.handleClick);
    };
    _proto.UNSAFE_componentWillUpdate = function UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (nextState.contentType !== this.state.contentType && !!this.media) {
            this.media = null;
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var _this = this;
        var _this_state = this.state, contentType = _this_state.contentType, contentUrl = _this_state.contentUrl;
        var _this_props = this.props, visible = _this_props.visible, currentSlide = _this_props.currentSlide;
        if (currentSlide !== prevProps.currentSlide) {
            this.handleClose();
        }
        if (prevProps.visible !== visible) {
            if (!!this.media && !visible) {
                this.media.pause();
            }
            if (!!this.media && visible) {
                this.media.play();
            }
        }
        if (contentUrl !== prevState.contentUrl && contentType === "image") {
            var img = new Image();
            img.onload = function() {
                _this.setState({
                    loading: false
                });
            };
            img.src = contentUrl;
        }
        if (contentUrl !== prevState.contentUrl && contentUrl && contentType === "video" && !!this.mediaEL && !this.media) {
            var node = this.mediaEL;
            var chartEL = document.querySelector(".chart");
            // eslint-disable-next-line no-unused-vars
            var me = new MediaElement(node, {
                plugins: [
                    "flash"
                ],
                pluginPath: "assets/flash/",
                defaultVideoHeight: chartEL ? Math.min(chartEL.offsetHeight, 512) : 512,
                defaultVideoWidth: chartEL ? Math.min(chartEL.offsetWidth, 800) : 960,
                enableAutosize: false,
                success: function(media) {
                    _this.media = media;
                    _this.media.load();
                    media.play();
                }
            });
        } else if (contentUrl !== prevState.contentUrl && contentUrl && contentType === "video" && !!this.mediaEL && !!this.media) {
            this.media.setSrc(contentUrl);
            this.media.load();
            this.media.play();
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _this_state = this.state, contentUrl = _this_state.contentUrl, loading = _this_state.loading, contentType = _this_state.contentType;
        var visible = this.props.visible;
        var classes = visible ? "app-modal app-modal__opened" : "app-modal";
        var body = /*#__PURE__*/ React.createElement("div", null);
        switch(contentType){
            case "image":
                body = /*#__PURE__*/ React.createElement("img", {
                    src: contentUrl,
                    className: "app-modal__img"
                });
                break;
            case "video":
                body = /*#__PURE__*/ React.createElement("div", {
                    className: "app-modal__video-wrapper"
                }, /*#__PURE__*/ React.createElement("video", {
                    src: contentUrl,
                    ref: function(el) {
                        _this.mediaEL = el;
                    },
                    className: "app-modal__video",
                    width: "962",
                    height: "512",
                    controls: true
                }));
                break;
            default:
                break;
        }
        return /*#__PURE__*/ React.createElement(CSSTransition, {
            in: visible,
            timeout: 300,
            classNames: "app-modal"
        }, /*#__PURE__*/ React.createElement("div", {
            className: classes,
            onClick: contentType === "image" ? this.handleClose : null
        }, /*#__PURE__*/ React.createElement("button", {
            type: "button",
            className: "app-modal__close",
            "aria-label": "Close",
            onClick: this.handleClose
        }, /*#__PURE__*/ React.createElement("span", {
            "aria-hidden": "true"
        }, "\xd7")), /*#__PURE__*/ React.createElement("div", {
            className: "app-modal__wrapper"
        }, !!contentUrl && !loading ? body : /*#__PURE__*/ React.createElement("span", {
            className: "app-modal__loader"
        }, "Loading"))));
    };
    return AppModal;
}(PureComponent);
AppModal.propTypes = {
    show: PropTypes.func,
    close: PropTypes.func
};
export default AppModal;
